<template>
    <transition name="slide-fade">
    <s-form-group :id="id" v-if="schema.config[fieldName].show" :class="schema.config[fieldName].stateClass">
            <s-form-group :label="fieldLabel+schema.config[fieldName].domElements.requiredIndicator" :label-for="schema.config[fieldName].id">
                <s-form-select
                        :name="fieldName"
                        :id="schema.config[fieldName].id"
                        :multiple="multiple"
                        :options="getOptions"
                        :maxlength="schema.config[fieldName].maxlength"
                        :aria-required="schema.config[fieldName].validation.required"
                        :data-vv-as="$t('message.fields.'+fieldName+'.label')"
                        v-validate="schema.config[fieldName].validation"
                        v-on:input="limitSelection"
                        v-model="schema.fields[fieldName]">
                </s-form-select>
            </s-form-group>        
        <span class="py-field-msg">{{ errors.first(fieldName) }}</span>
    </s-form-group>
    </transition>
</template>

<script>

    import sFormGroup from '../form/s-form-group'
    import sFormSelect from '../form/s-form-select'
    import formHelpers from '../../utils/helpers/formHelpers'

    export default {
        name: 'sSelectGroup',
        mixins: [formHelpers],
        props:{
            fieldName: String,
            multiple: String,
            label: String,
            limit: Number
        },

        data() {
          return {
              schema: this.$root.$data.schema,
              id: 'py-formGroup-'+this.fieldName,
              fieldLabel: (typeof this.label === "undefined") ? this.$i18n.t('message.fields.'+this.fieldName+'.label') : this.label
          }
        },
        methods: { 
        limitSelection(selectedItems) {
            //logic to limit number of items selected.
            if(this.limit) {
                const selectedValues = this.schema.fields[this.fieldName];
                const allOptions = this.schema.config[this.fieldName].options;
                if( selectedItems.length >= this.limit) {
                    allOptions.forEach((item) => {
                    if(selectedValues.indexOf(item.value) === -1 && item) {
                        document.querySelector(`option[value="${item.value}"]`).disabled = true;
                        document.querySelector(`option[value="${item.value}"]`).style.cursor = "not-allowed";
                    }
                });
                } else {
                    allOptions.forEach((item) => {       
                        item && document.querySelector(`option[value="${item.value}"]`).removeAttribute("disabled");
                        if(item) document.querySelector(`option[value="${item.value}"]`).style.cursor = "auto";
                    });
                }
            }
        }  
        },
        computed : {
            getOptions() {
             //getting rid of blank space in products list
                let { options } = this.schema.config[this.fieldName];
                if (options && Array.isArray(options)){
                 if(options[0] === '') options = options.slice(1);
                }
                return options     
            }
        },
        inject: {
            $validator: '$validator'
        },
        components: {
            sFormSelect,
            sFormGroup
        },
        mounted(){
           this.addEventListeners();
        }
    }

</script>

